export const defineErrorText = (error) => {
  if (ERROR_CODES.minQuantityTen.some((err) => err === error)) return t.form.serverErrors.minQuantityTen;
  else if (ERROR_CODES.ips.some((err) => err === error)) return t.form.serverErrors.ips;
  else return t.form.serverErrors.default;
};
